<template>
<div class="ranks">
    <Header />
    <div class="rank-banner" :style="{backgroundImage:'url('+detail.pcCoverImage+')'}">
        <div class="main-center-cont"><img :src="detail.pcCoverImage" alt=""></div>
    </div>
    <div class="infos">
        <div class="description">{{detail.description}}</div>
        <ul class="shop-infos">
            <li v-for="(item,index) in detail.items" :key="item.id">
                <a :href="'/'+ item.topics[0].businessType.name_en +'/'+item.topics[0].englishName+'/'+ ( item.merchantId || item.postId ) | hostBuild('info')" class="cover-img">
                    <div class="top-icon">
                        <img :src="require('@/assets/images/info/rank-0'+(index+1)+'.png')" alt="" v-if="index <9" width="44">
                        <img :src="require('@/assets/images/info/rank-10.png')" alt="" v-if="index ==9" width="44">
                    </div>
                    <img :src="item.logo||item.coverImage" alt="">
                </a>
                <div class="flex-cont">
                    <a :href="'/'+ item.topics[0].businessType.name_en +'/'+item.topics[0].englishName+'/'+ ( item.merchantId || item.postId ) |hostBuild('info')" class="title">
                        <span v-if="item.shopCnName && item.shopEnName">{{ item.shopCnName }} ({{ item.shopEnName }}) </span>
                        <span v-else-if="item.shopCnName">{{ item.shopCnName }} </span>
                        <span v-else-if="item.shopEnName">{{ item.shopEnName }} </span>
                        <span v-if="item.shopCnName != item.title">{{ item.title }}</span>
                    </a>
                    <div class="reason" v-if="item.description">{{item.description}}</div>
                    <div class="tags">
                        <div class="tag-item" v-for="tag in item.tags" :key="tag.id">{{tag.name}}</div>
                        
                    </div>
                    <div class="address" v-if="item.address">{{item.address}}</div>
                    <div class="subf-info" v-if="item.gstars >0 ">
                        <div class="pice" v-if="item.gstars >0 "><span>{{item.gstars}}</span>评分</div>
                        <!-- <div class="pice"><span>{{item.postcode}}</span>条评论</div> -->
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="rank-suject-model">

        <SubjectModel :info="subjectData"  v-if="!pageLoading"/>
    </div>
    <FooterSimple />
    <div class="look-more-rank"><a :href="`/rank/type/${detail.type.id}`"><img width="60" :src="require('@/assets/images/info/more-rank.png')" alt=""></a></div>
</div>
</template>
<script>
import Header from '@/common/header/header.vue'
import SubjectModel from '@/pages/news/specialSubject/component/subject-model.vue'
import FooterSimple from '@/common/footer/footer-simple.vue'
import {setHtmlMeta} from '@/utils/utils.js'
export default {
    name:'RankInfos',
    components:{SubjectModel,Header,FooterSimple},
    data(){
        return {
            pageLoading:true,
            detail:{
                items:[],
                type:{}
            },
            subjectData :{
                subjectIds:[],
                dataOrigin:['bbs_post','cms_post'],
                defaultList:0,
                title:'相关话题',
                imgType:9,
            }
        }
    },
    created(){
        console.log('看走不走这里');
        this.getData();
    },
    methods:{
        async getData(){
            let result = await this.$axios.post('/rankings/frontend/v1/get/rankings/by/name/en',{nameEn:this.$route.params.name})
            console.log('获取详情--->',result)
            this.pageLoading = false;
            if( result.code == 0 ){
                this.detail = result.data;
                for(var i=0; i<result.data.subjects.length; i++){
                    this.subjectData.subjectIds.push(result.data.subjects[i].id)
                }
                setHtmlMeta({
                    title:this.detail.seoTitle || this.detail.name + '约克论坛 - 加拿大第一中文网',
                    keywords:this.detail.seoKeywords || this.detail.name,
                    description:this.detail.seoDescription || this.detail.description,
                });
            }
            if( result.code == -1 ){
                this.$router.replace('/404');
            }
        },
        
    }
}
</script>
<style lang="scss" scoped>
.ranks{background: #f8f8f8;}
.rank-banner{background-position: center top; background-repeat: no-repeat;}
.main-center-cont{width:720px; overflow: hidden; margin:0 auto;
    img{max-width: inherit; margin-left: 50%; transform: translateX(-50%);}
}
.infos{
    width: 720px; position: relative; z-index: 2; margin: -30px auto 0; padding: 40px 30px 30px; box-sizing: border-box;
    background: #fff; border-radius: 10px;
    .description{
        padding:0 30px 20px 30px; margin-bottom: 20px; border-bottom: 1px solid #eee;
        position: relative;
        font-size: 16px; line-height: 30px;
        &:before{
            position: absolute; left: 0; top: -7px; content:''; 
            width: 20px; height: 17px;
            background: url(@/assets/images/subject/top-quotes.png) no-repeat;
        }
        &:after{
            position: absolute; right: 0; bottom: 30px; content:'';
            width: 20px; height: 17px;
            background: url(@/assets/images/subject/down-quotes.png) no-repeat;
        }
    }
    .shop-infos{
        li{
            display: flex; padding:15px 0 ;
            .cover-img{
                display: block; position: relative; font-size: 0; width: 170px; margin-right: 20px;
                &:after{
                    position: relative; content: ''; display: inline-block; padding-bottom: 75%;
                }

                .top-icon{
                    position: absolute; z-index: 2; left: 0; top: 0;
                }
                >img{
                    position: absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover; border-radius: 8px;
                }
            }
            .flex-cont{flex:1; overflow: hidden;}
        }   
        .title{
            display: block; font-size: 16px; color: #111;
        }
        .reason{ 
            margin-top: 10px; font-size: 14px; white-space: nowrap; color: #FE0000; overflow: hidden;
        }
        .tags{
            display:flex; flex-wrap: wrap;
            .tag-item{
                font-size: 14px; line-height: 24px; padding:  0 5px; 
                margin: 10px 10px 0 0 ; background: #f8f8f8; color: #666; border-radius: 4px;
            }
        }
        .address{font-size: 14px; line-height: 20px; color: #666; margin-top: 10px;}
        .subf-info{
            display: flex; margin-top: 10px;
            .pice{
                margin-right: 20px; color: #999; font-size: 12px;
                span{color: #0065FE;}
            }
        }
    }
}
.rank-suject-model{
    width: 720px; margin: 30px auto;
    ::v-deep{
        .post-cont{
            .item{
                background: #fff; padding: 20px; border: none;
            }
        }
    }
}
.look-more-rank{position: fixed; z-index: 5; left: 50%; bottom: 100px; margin-left: 400px; }
</style>